import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem('proaktif_user');
    return u ? JSON.parse(u) : null;
  });
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
      localStorage.setItem('proaktif_user', JSON.stringify(data));
    } catch (e) {
      // ignore
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('proaktif_token');
    if (token) refreshMe();
    else setLoading(false);
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('proaktif_token', data.access_token);
    localStorage.setItem('proaktif_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (e) {}
    localStorage.removeItem('proaktif_token');
    localStorage.removeItem('proaktif_user');
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

// Role-based menu permissions
export const ROLE_LABEL = {
  admin: 'Administrator Sistem',
  operator: 'Operator Prokopim',
  kabag: 'Kabag Prokopim',
  pimpinan: 'Pimpinan',
  delegasi: 'Pejabat Delegasi',
};

export const ROLE_BADGE = {
  admin: 'bg-status-info-soft',
  operator: 'bg-status-warn-soft',
  kabag: 'bg-status-success-soft',
  pimpinan: 'bg-[hsl(0_72%_51%_/0.12)] text-[hsl(0_72%_38%)]',
  delegasi: 'bg-status-neutral-soft',
};
